// ── 보스 결정석 가격 데이터 ──────────────────────────
// 가격 변경 시 이 파일만 수정하세요.
// 날짜 기준으로 가격이 자동 분기됩니다.

const BOSS_PRICE_HISTORY = [
  // ── 2026-06-18 패치 이전 ──
  {
    from: "2000-01-01",
    to:   "2026-06-17",
    daily: [
      { name:"자쿰",           diffs:[{diff:"이지",crystal:114000},{diff:"노멀",crystal:349000}] },
      { name:"혼테일",         diffs:[{diff:"이지",crystal:502000},{diff:"노멀",crystal:576000},{diff:"카오스",crystal:770000}] },
      { name:"매그너스",       diffs:[{diff:"이지",crystal:411000},{diff:"노멀",crystal:1480000}] },
      { name:"힐라",           diffs:[{diff:"노멀",crystal:455000}] },
      { name:"카응",           diffs:[{diff:"노멀",crystal:712000}] },
      { name:"파풀라투스",     diffs:[{diff:"이지",crystal:390000},{diff:"노멀",crystal:1520000}] },
      { name:"피에르",         diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반반",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"블러디퀸",       diffs:[{diff:"노멀",crystal:551000}] },
      { name:"벨룸",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반 레온",        diffs:[{diff:"이지",crystal:602000},{diff:"노멀",crystal:830000},{diff:"하드",crystal:1390000}] },
      { name:"아카이럼",       diffs:[{diff:"이지",crystal:656000},{diff:"노멀",crystal:1430000}] },
      { name:"핑크빈",         diffs:[{diff:"노멀",crystal:799000}] },
    ],
    weekly: [
      { name:"자쿰",              diffs:[{diff:"카오스",crystal:8080000}] },
      { name:"매그너스",          diffs:[{diff:"하드",crystal:8560000}] },
      { name:"힐라",              diffs:[{diff:"하드",crystal:5750000}] },
      { name:"파풀라투스",        diffs:[{diff:"카오스",crystal:13800000}] },
      { name:"피에르",            diffs:[{diff:"카오스",crystal:8170000}] },
      { name:"반반",              diffs:[{diff:"카오스",crystal:8150000}] },
      { name:"블러디퀸",          diffs:[{diff:"카오스",crystal:8140000}] },
      { name:"벨룸",              diffs:[{diff:"카오스",crystal:9280000}] },
      { name:"핑크빈",            diffs:[{diff:"카오스",crystal:6580000}] },
      { name:"시그너스",          diffs:[{diff:"이지",crystal:4550000},{diff:"노멀",crystal:7500000}] },
      { name:"스우",              diffs:[{diff:"노멀",crystal:17600000},{diff:"하드",crystal:54200000},{diff:"익스트림",crystal:604000000}] },
      { name:"데미안",            diffs:[{diff:"노멀",crystal:18400000},{diff:"하드",crystal:51500000}] },
      { name:"가디언 엔젤 슬라임",diffs:[{diff:"노멀",crystal:26800000},{diff:"카오스",crystal:79100000}] },
      { name:"루시드",            diffs:[{diff:"이지",crystal:31400000},{diff:"노멀",crystal:37500000},{diff:"하드",crystal:66200000}] },
      { name:"윌",                diffs:[{diff:"이지",crystal:34000000},{diff:"노멀",crystal:43300000},{diff:"하드",crystal:81200000}] },
      { name:"더스크",            diffs:[{diff:"노멀",crystal:46300000},{diff:"카오스",crystal:73500000}] },
      { name:"진 힐라",           diffs:[{diff:"노멀",crystal:74900000},{diff:"하드",crystal:112000000}] },
      { name:"듄켈",              diffs:[{diff:"노멀",crystal:50000000},{diff:"하드",crystal:99400000}] },
      { name:"세렌",              diffs:[{diff:"노멀",crystal:266000000},{diff:"하드",crystal:396000000},{diff:"익스트림",crystal:3150000000}] },
      { name:"칼로스",            diffs:[{diff:"이지",crystal:311000000},{diff:"노멀",crystal:561000000},{diff:"카오스",crystal:1340000000},{diff:"익스트림",crystal:4320000000}] },
      { name:"최초의 대적자",     diffs:[{diff:"이지",crystal:324000000},{diff:"노멀",crystal:589000000},{diff:"하드",crystal:1510000000},{diff:"익스트림",crystal:4960000000}] },
      { name:"카링",              diffs:[{diff:"이지",crystal:419000000},{diff:"노멀",crystal:714000000},{diff:"하드",crystal:1830000000},{diff:"익스트림",crystal:5670000000}] },
      { name:"찬란한 흉성",       diffs:[{diff:"노멀",crystal:658000000},{diff:"하드",crystal:2819000000}] },
      { name:"림보",              diffs:[{diff:"노멀",crystal:1080000000},{diff:"하드",crystal:2510000000}] },
      { name:"발드릭스",          diffs:[{diff:"노멀",crystal:1440000000},{diff:"하드",crystal:3240000000}] },
      { name:"유피테르",          diffs:[{diff:"노멀",crystal:1700000000},{diff:"하드",crystal:5100000000}] },
    ],
    monthly: [
      { name:"검은 마법사", diffs:[{diff:"하드",crystal:665000000},{diff:"익스트림",crystal:8740000000}] },
    ],
  },

  // ── 2026-06-18 패치 이후 ──
  {
    from: "2026-06-18",
    to:   "2026-08-19",
    daily: [
      { name:"자쿰",           diffs:[{diff:"이지",crystal:110000},{diff:"노멀",crystal:350000}] },
      { name:"매그너스",       diffs:[{diff:"이지",crystal:410000},{diff:"노멀",crystal:1160000}] },
      { name:"힐라",           diffs:[{diff:"노멀",crystal:460000},{diff:"하드",crystal:1280000}] },
      { name:"카웅",           diffs:[{diff:"노멀",crystal:710000}] },
      { name:"파풀라투스",     diffs:[{diff:"이지",crystal:390000},{diff:"노멀",crystal:1200000}] },
      { name:"피에르",         diffs:[{diff:"노멀",crystal:550000}] },
      { name:"반반",           diffs:[{diff:"노멀",crystal:550000}] },
      { name:"블러디퀸",       diffs:[{diff:"노멀",crystal:550000}] },
      { name:"벨룸",           diffs:[{diff:"노멀",crystal:550000}] },
      { name:"반 레온",        diffs:[{diff:"이지",crystal:600000},{diff:"노멀",crystal:830000},{diff:"하드",crystal:1070000}] },
      { name:"혼테일",         diffs:[{diff:"이지",crystal:500000},{diff:"노멀",crystal:580000},{diff:"카오스",crystal:770000}] },
      { name:"아카이럼",       diffs:[{diff:"이지",crystal:660000},{diff:"노멀",crystal:1110000}] },
      { name:"핑크빈",         diffs:[{diff:"노멀",crystal:800000},{diff:"카오스",crystal:1320000}] },
      { name:"시그너스",       diffs:[{diff:"노멀",crystal:1360000}] },
    ],
    weekly: [
      { name:"자쿰",              diffs:[{diff:"카오스",crystal:8080000}] },
      { name:"매그너스",          diffs:[{diff:"하드",crystal:8560000}] },
      { name:"파풀라투스",        diffs:[{diff:"카오스",crystal:13100000}] },
      { name:"피에르",            diffs:[{diff:"카오스",crystal:8170000}] },
      { name:"반반",              diffs:[{diff:"카오스",crystal:8150000}] },
      { name:"블러디퀸",          diffs:[{diff:"카오스",crystal:8140000}] },
      { name:"벨룸",              diffs:[{diff:"카오스",crystal:9280000}] },
      { name:"스우",              diffs:[{diff:"노멀",crystal:16700000},{diff:"하드",crystal:51500000},{diff:"익스트림",crystal:574000000}] },
      { name:"데미안",            diffs:[{diff:"노멀",crystal:17500000},{diff:"하드",crystal:48900000}] },
      { name:"루시드",            diffs:[{diff:"이지",crystal:29800000},{diff:"노멀",crystal:35600000},{diff:"하드",crystal:62900000}] },
      { name:"가디언 엔젤 슬라임",diffs:[{diff:"노멀",crystal:25500000},{diff:"카오스",crystal:75100000}] },
      { name:"윌",                diffs:[{diff:"이지",crystal:32300000},{diff:"노멀",crystal:41100000},{diff:"하드",crystal:77100000}] },
      { name:"더스크",            diffs:[{diff:"노멀",crystal:44000000},{diff:"카오스",crystal:69800000}] },
      { name:"진 힐라",           diffs:[{diff:"노멀",crystal:71200000},{diff:"하드",crystal:106000000}] },
      { name:"듄켈",              diffs:[{diff:"노멀",crystal:47500000},{diff:"하드",crystal:94400000}] },
      { name:"선택받은 세렌",     diffs:[{diff:"노멀",crystal:239000000},{diff:"하드",crystal:356000000},{diff:"익스트림",crystal:2835000000}] },
      { name:"감시자 칼로스",     diffs:[{diff:"이지",crystal:280000000},{diff:"노멀",crystal:505000000},{diff:"카오스",crystal:1273000000},{diff:"익스트림",crystal:4104000000}] },
      { name:"최초의 대적자",     diffs:[{diff:"이지",crystal:308000000},{diff:"노멀",crystal:560000000},{diff:"하드",crystal:1435000000},{diff:"익스트림",crystal:4712000000}] },
      { name:"카링",              diffs:[{diff:"이지",crystal:377000000},{diff:"노멀",crystal:678000000},{diff:"하드",crystal:1739000000},{diff:"익스트림",crystal:5387000000}] },
      { name:"찬란한 흉성",       diffs:[{diff:"노멀",crystal:625000000},{diff:"하드",crystal:2678000000}] },
      { name:"림보",              diffs:[{diff:"노멀",crystal:1026000000},{diff:"하드",crystal:2385000000}] },
      { name:"발드릭스",          diffs:[{diff:"노멀",crystal:1368000000},{diff:"하드",crystal:3078000000}] },
      { name:"유피테르",          diffs:[{diff:"노멀",crystal:1615000000},{diff:"하드",crystal:4845000000}] },
    ],
    monthly: [
      { name:"검은 마법사", diffs:[{diff:"하드",crystal:665000000},{diff:"익스트림",crystal:8740000000}] },
    ],
  },
  // ── 2026-08-20 패치 (신규 보스 벨로나 추가) ──
  {
    from: "2026-08-20",
    to:   "2026-09-16",
    daily: [
      { name:"자쿰",           diffs:[{diff:"이지",crystal:114000},{diff:"노멀",crystal:349000}] },
      { name:"매그너스",       diffs:[{diff:"이지",crystal:411000},{diff:"노멀",crystal:1160000}] },
      { name:"힐라",           diffs:[{diff:"노멀",crystal:455000},{diff:"하드",crystal:1280000}] },
      { name:"카웅",           diffs:[{diff:"노멀",crystal:712000}] },
      { name:"파풀라투스",     diffs:[{diff:"이지",crystal:390000},{diff:"노멀",crystal:1200000}] },
      { name:"피에르",         diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반반",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"블러디퀸",       diffs:[{diff:"노멀",crystal:551000}] },
      { name:"벨룸",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반 레온",        diffs:[{diff:"이지",crystal:602000},{diff:"노멀",crystal:830000},{diff:"하드",crystal:1070000}] },
      { name:"혼테일",         diffs:[{diff:"이지",crystal:502000},{diff:"노멀",crystal:576000},{diff:"카오스",crystal:770000}] },
      { name:"아카이럼",       diffs:[{diff:"이지",crystal:656000},{diff:"노멀",crystal:1110000}] },
      { name:"핑크빈",         diffs:[{diff:"노멀",crystal:799000},{diff:"카오스",crystal:1320000}] },
      { name:"시그너스",       diffs:[{diff:"노멀",crystal:1360000}] },
    ],
    weekly: [
      { name:"자쿰",              diffs:[{diff:"카오스",crystal:8080000}] },
      { name:"매그너스",          diffs:[{diff:"하드",crystal:8560000}] },
      { name:"파풀라투스",        diffs:[{diff:"카오스",crystal:13100000}] },
      { name:"피에르",            diffs:[{diff:"카오스",crystal:8170000}] },
      { name:"반반",              diffs:[{diff:"카오스",crystal:8150000}] },
      { name:"블러디퀸",          diffs:[{diff:"카오스",crystal:8140000}] },
      { name:"벨룸",              diffs:[{diff:"카오스",crystal:9280000}] },
      { name:"스우",              diffs:[{diff:"노멀",crystal:16700000},{diff:"하드",crystal:51500000},{diff:"익스트림",crystal:574000000}] },
      { name:"데미안",            diffs:[{diff:"노멀",crystal:17500000},{diff:"하드",crystal:48900000}] },
      { name:"루시드",            diffs:[{diff:"이지",crystal:29800000},{diff:"노멀",crystal:35600000},{diff:"하드",crystal:62900000}] },
      { name:"가디언 엔젤 슬라임",diffs:[{diff:"노멀",crystal:25500000},{diff:"카오스",crystal:75100000}] },
      { name:"윌",                diffs:[{diff:"이지",crystal:32300000},{diff:"노멀",crystal:41100000},{diff:"하드",crystal:77100000}] },
      { name:"더스크",            diffs:[{diff:"노멀",crystal:44000000},{diff:"카오스",crystal:69800000}] },
      { name:"진 힐라",           diffs:[{diff:"노멀",crystal:71200000},{diff:"하드",crystal:106000000}] },
      { name:"듄켈",              diffs:[{diff:"노멀",crystal:47500000},{diff:"하드",crystal:94400000}] },
      { name:"선택받은 세렌",     diffs:[{diff:"노멀",crystal:239000000},{diff:"하드",crystal:356000000},{diff:"익스트림",crystal:2835000000}] },
      { name:"감시자 칼로스",     diffs:[{diff:"이지",crystal:280000000},{diff:"노멀",crystal:505000000},{diff:"카오스",crystal:1273000000},{diff:"익스트림",crystal:4104000000}] },
      { name:"최초의 대적자",     diffs:[{diff:"이지",crystal:308000000},{diff:"노멀",crystal:560000000},{diff:"하드",crystal:1435000000},{diff:"익스트림",crystal:4712000000}] },
      { name:"카링",              diffs:[{diff:"이지",crystal:377000000},{diff:"노멀",crystal:678000000},{diff:"하드",crystal:1739000000},{diff:"익스트림",crystal:5387000000}] },
      { name:"벨로나",            diffs:[{diff:"이지",crystal:440000000},{diff:"노멀",crystal:850000000},{diff:"하드",crystal:2950000000}] },
      { name:"찬란한 흉성",       diffs:[{diff:"노멀",crystal:625000000},{diff:"하드",crystal:2678000000}] },
      { name:"림보",              diffs:[{diff:"노멀",crystal:1026000000},{diff:"하드",crystal:2385000000}] },
      { name:"발드릭스",          diffs:[{diff:"노멀",crystal:1368000000},{diff:"하드",crystal:3078000000}] },
      { name:"유피테르",          diffs:[{diff:"노멀",crystal:1615000000},{diff:"하드",crystal:4845000000}] },
    ],
    monthly: [
      { name:"검은 마법사", diffs:[{diff:"하드",crystal:665000000},{diff:"익스트림",crystal:8740000000}] },
    ],
  },

  // ── 2026-09-17 보스 결정석 대규모 너프 (주간보스 -3~50%) ──
  //    일간보스는 이번 패치로 가격 변동 없음.
  //    검은 마법사(월간보스)는 10/1부터 적용이라 이 기간엔 기존 가격 유지.
  {
    from: "2026-09-17",
    to:   "2026-09-30",
    daily: [
      { name:"자쿰",           diffs:[{diff:"이지",crystal:114000},{diff:"노멀",crystal:349000}] },
      { name:"매그너스",       diffs:[{diff:"이지",crystal:411000},{diff:"노멀",crystal:1160000}] },
      { name:"힐라",           diffs:[{diff:"노멀",crystal:455000},{diff:"하드",crystal:1280000}] },
      { name:"카웅",           diffs:[{diff:"노멀",crystal:712000}] },
      { name:"파풀라투스",     diffs:[{diff:"이지",crystal:390000},{diff:"노멀",crystal:1200000}] },
      { name:"피에르",         diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반반",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"블러디퀸",       diffs:[{diff:"노멀",crystal:551000}] },
      { name:"벨룸",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반 레온",        diffs:[{diff:"이지",crystal:602000},{diff:"노멀",crystal:830000},{diff:"하드",crystal:1070000}] },
      { name:"혼테일",         diffs:[{diff:"이지",crystal:502000},{diff:"노멀",crystal:576000},{diff:"카오스",crystal:770000}] },
      { name:"아카이럼",       diffs:[{diff:"이지",crystal:656000},{diff:"노멀",crystal:1110000}] },
      { name:"핑크빈",         diffs:[{diff:"노멀",crystal:799000},{diff:"카오스",crystal:1320000}] },
      { name:"시그너스",       diffs:[{diff:"노멀",crystal:1360000}] },
    ],
    weekly: [
      { name:"자쿰",              diffs:[{diff:"카오스",crystal:4040000}] },
      { name:"매그너스",          diffs:[{diff:"하드",crystal:4280000}] },
      { name:"파풀라투스",        diffs:[{diff:"카오스",crystal:6550000}] },
      { name:"피에르",            diffs:[{diff:"카오스",crystal:4080000}] },
      { name:"반반",              diffs:[{diff:"카오스",crystal:4070000}] },
      { name:"블러디퀸",          diffs:[{diff:"카오스",crystal:4070000}] },
      { name:"벨룸",              diffs:[{diff:"카오스",crystal:4640000}] },
      { name:"스우",              diffs:[{diff:"노멀",crystal:8350000},{diff:"하드",crystal:48900000},{diff:"익스트림",crystal:545000000}] },
      { name:"데미안",            diffs:[{diff:"노멀",crystal:8750000},{diff:"하드",crystal:46400000}] },
      { name:"루시드",            diffs:[{diff:"이지",crystal:14900000},{diff:"노멀",crystal:17800000},{diff:"하드",crystal:59700000}] },
      { name:"가디언 엔젤 슬라임",diffs:[{diff:"노멀",crystal:12700000},{diff:"카오스",crystal:71300000}] },
      { name:"윌",                diffs:[{diff:"이지",crystal:16100000},{diff:"노멀",crystal:20500000},{diff:"하드",crystal:73200000}] },
      { name:"더스크",            diffs:[{diff:"노멀",crystal:22000000},{diff:"카오스",crystal:66300000}] },
      { name:"진 힐라",           diffs:[{diff:"노멀",crystal:67600000},{diff:"하드",crystal:100000000}] },
      { name:"듄켈",              diffs:[{diff:"노멀",crystal:23700000},{diff:"하드",crystal:89600000}] },
      { name:"선택받은 세렌",     diffs:[{diff:"노멀",crystal:167000000},{diff:"하드",crystal:302000000},{diff:"익스트림",crystal:1840000000}] },
      { name:"감시자 칼로스",     diffs:[{diff:"이지",crystal:238000000},{diff:"노멀",crystal:479000000},{diff:"카오스",crystal:1230000000},{diff:"익스트림",crystal:4104000000}] },
      { name:"최초의 대적자",     diffs:[{diff:"이지",crystal:261000000},{diff:"노멀",crystal:532000000},{diff:"하드",crystal:1390000000},{diff:"익스트림",crystal:4712000000}] },
      { name:"카링",              diffs:[{diff:"이지",crystal:320000000},{diff:"노멀",crystal:576000000},{diff:"하드",crystal:1560000000},{diff:"익스트림",crystal:5387000000}] },
      { name:"벨로나",            diffs:[{diff:"이지",crystal:396000000},{diff:"노멀",crystal:824000000},{diff:"하드",crystal:2950000000}] },
      { name:"찬란한 흉성",       diffs:[{diff:"노멀",crystal:593000000},{diff:"하드",crystal:2678000000}] },
      { name:"림보",              diffs:[{diff:"노멀",crystal:995000000},{diff:"하드",crystal:2385000000}] },
      { name:"발드릭스",          diffs:[{diff:"노멀",crystal:1320000000},{diff:"하드",crystal:3078000000}] },
      { name:"유피테르",          diffs:[{diff:"노멀",crystal:1560000000},{diff:"하드",crystal:4845000000}] },
    ],
    monthly: [
      { name:"검은 마법사", diffs:[{diff:"하드",crystal:665000000},{diff:"익스트림",crystal:8740000000}] },
    ],
  },

  // ── 2026-10-01 ~: 검은 마법사(월간보스) 너프까지 전부 적용 ──
  {
    from: "2026-10-01",
    to:   "9999-12-31",
    daily: [
      { name:"자쿰",           diffs:[{diff:"이지",crystal:114000},{diff:"노멀",crystal:349000}] },
      { name:"매그너스",       diffs:[{diff:"이지",crystal:411000},{diff:"노멀",crystal:1160000}] },
      { name:"힐라",           diffs:[{diff:"노멀",crystal:455000},{diff:"하드",crystal:1280000}] },
      { name:"카웅",           diffs:[{diff:"노멀",crystal:712000}] },
      { name:"파풀라투스",     diffs:[{diff:"이지",crystal:390000},{diff:"노멀",crystal:1200000}] },
      { name:"피에르",         diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반반",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"블러디퀸",       diffs:[{diff:"노멀",crystal:551000}] },
      { name:"벨룸",           diffs:[{diff:"노멀",crystal:551000}] },
      { name:"반 레온",        diffs:[{diff:"이지",crystal:602000},{diff:"노멀",crystal:830000},{diff:"하드",crystal:1070000}] },
      { name:"혼테일",         diffs:[{diff:"이지",crystal:502000},{diff:"노멀",crystal:576000},{diff:"카오스",crystal:770000}] },
      { name:"아카이럼",       diffs:[{diff:"이지",crystal:656000},{diff:"노멀",crystal:1110000}] },
      { name:"핑크빈",         diffs:[{diff:"노멀",crystal:799000},{diff:"카오스",crystal:1320000}] },
      { name:"시그너스",       diffs:[{diff:"노멀",crystal:1360000}] },
    ],
    weekly: [
      { name:"자쿰",              diffs:[{diff:"카오스",crystal:4040000}] },
      { name:"매그너스",          diffs:[{diff:"하드",crystal:4280000}] },
      { name:"파풀라투스",        diffs:[{diff:"카오스",crystal:6550000}] },
      { name:"피에르",            diffs:[{diff:"카오스",crystal:4080000}] },
      { name:"반반",              diffs:[{diff:"카오스",crystal:4070000}] },
      { name:"블러디퀸",          diffs:[{diff:"카오스",crystal:4070000}] },
      { name:"벨룸",              diffs:[{diff:"카오스",crystal:4640000}] },
      { name:"스우",              diffs:[{diff:"노멀",crystal:8350000},{diff:"하드",crystal:48900000},{diff:"익스트림",crystal:545000000}] },
      { name:"데미안",            diffs:[{diff:"노멀",crystal:8750000},{diff:"하드",crystal:46400000}] },
      { name:"루시드",            diffs:[{diff:"이지",crystal:14900000},{diff:"노멀",crystal:17800000},{diff:"하드",crystal:59700000}] },
      { name:"가디언 엔젤 슬라임",diffs:[{diff:"노멀",crystal:12700000},{diff:"카오스",crystal:71300000}] },
      { name:"윌",                diffs:[{diff:"이지",crystal:16100000},{diff:"노멀",crystal:20500000},{diff:"하드",crystal:73200000}] },
      { name:"더스크",            diffs:[{diff:"노멀",crystal:22000000},{diff:"카오스",crystal:66300000}] },
      { name:"진 힐라",           diffs:[{diff:"노멀",crystal:67600000},{diff:"하드",crystal:100000000}] },
      { name:"듄켈",              diffs:[{diff:"노멀",crystal:23700000},{diff:"하드",crystal:89600000}] },
      { name:"선택받은 세렌",     diffs:[{diff:"노멀",crystal:167000000},{diff:"하드",crystal:302000000},{diff:"익스트림",crystal:1840000000}] },
      { name:"감시자 칼로스",     diffs:[{diff:"이지",crystal:238000000},{diff:"노멀",crystal:479000000},{diff:"카오스",crystal:1230000000},{diff:"익스트림",crystal:4104000000}] },
      { name:"최초의 대적자",     diffs:[{diff:"이지",crystal:261000000},{diff:"노멀",crystal:532000000},{diff:"하드",crystal:1390000000},{diff:"익스트림",crystal:4712000000}] },
      { name:"카링",              diffs:[{diff:"이지",crystal:320000000},{diff:"노멀",crystal:576000000},{diff:"하드",crystal:1560000000},{diff:"익스트림",crystal:5387000000}] },
      { name:"벨로나",            diffs:[{diff:"이지",crystal:396000000},{diff:"노멀",crystal:824000000},{diff:"하드",crystal:2950000000}] },
      { name:"찬란한 흉성",       diffs:[{diff:"노멀",crystal:593000000},{diff:"하드",crystal:2678000000}] },
      { name:"림보",              diffs:[{diff:"노멀",crystal:995000000},{diff:"하드",crystal:2385000000}] },
      { name:"발드릭스",          diffs:[{diff:"노멀",crystal:1320000000},{diff:"하드",crystal:3078000000}] },
      { name:"유피테르",          diffs:[{diff:"노멀",crystal:1560000000},{diff:"하드",crystal:4845000000}] },
    ],
    monthly: [
      { name:"검은 마법사", diffs:[{diff:"하드",crystal:465000000},{diff:"익스트림",crystal:5680000000}] },
    ],
  },
];

// ── 여기서부터 범용 로직: 새 패치가 생겨도 이 아래는 손댈 필요 없음 ──

// 날짜에 해당하는 기간(period)의 배열 인덱스
function findPeriodIndex(date) {
  return BOSS_PRICE_HISTORY.findIndex(h => date >= h.from && date <= h.to);
}

function addDays(dateStr, n) {
  const d = new Date(dateStr + "T00:00:00");
  d.setDate(d.getDate() + n);
  // ⚠️ toISOString()은 UTC로 변환하기 때문에 한국(UTC+9) 등 UTC보다 빠른 시간대에서
  // 자정 기준 날짜가 하루 밀리는 버그가 있었음. 로컬 날짜 구성요소로 직접 조립해서 수정.
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

// 카테고리(daily/weekly/monthly) 단위로, 이 날짜가 "실제로 가격이 바뀐 첫날"인지 판단
// - 그 날짜가 현재 기간의 from과 정확히 같고
// - 바로 이전 날짜가 이전 기간의 to와 이어지며 (데이터가 끊긴 게 아니라 연속)
// - 이전 기간과 현재 기간의 해당 카테고리 값이 실제로 다를 때만 true
function isCategoryTransitionDay(date, category) {
  const idx = findPeriodIndex(date);
  if (idx <= 0) return false;
  const period = BOSS_PRICE_HISTORY[idx];
  if (date !== period.from) return false;
  const prev = BOSS_PRICE_HISTORY[idx - 1];
  if (addDays(prev.to, 1) !== period.from) return false; // 기간이 연속돼있지 않으면 전환일 아님
  return JSON.stringify(prev[category]) !== JSON.stringify(period[category]);
}

// 이 날짜에 daily/weekly/monthly 중 무엇이 "패치 전/후"로 갈리는지 반환
export function getPatchTransitionInfo(date) {
  return {
    daily:   isCategoryTransitionDay(date, "daily"),
    weekly:  isCategoryTransitionDay(date, "weekly"),
    monthly: isCategoryTransitionDay(date, "monthly"),
  };
}

// 이 날짜에 (카테고리 무관하게) 패치 전/후 선택 UI를 보여줘야 하는지
export function isPatchTransitionDate(date) {
  const info = getPatchTransitionInfo(date);
  return info.daily || info.weekly || info.monthly;
}

// 날짜(+선택적 phase) 기준 보스 그룹 반환
// phase: "before" | "after" (기본값 "after")
//   isPatchTransitionDate(date)가 true인 카테고리에 한해서만 "before"가 의미를 가짐.
//   (해당 날짜에 실제로 안 바뀐 카테고리는 phase와 무관하게 항상 같은 값 반환 → 안전함)
export function getBossData(date, phase) {
  const d = date || "9999-12-31";
  const idx = findPeriodIndex(d);
  const period = idx >= 0 ? BOSS_PRICE_HISTORY[idx] : BOSS_PRICE_HISTORY[BOSS_PRICE_HISTORY.length - 1];
  const prev = idx > 0 ? BOSS_PRICE_HISTORY[idx - 1] : null;
  const info = getPatchTransitionInfo(d);
  const useBefore = phase === "before";

  const pick = (category) => {
    if (useBefore && info[category] && prev) return prev[category];
    return period[category];
  };

  return {
    daily:   pick("daily"),
    weekly:  pick("weekly"),
    monthly: pick("monthly"),
  };
}